import { render, staticRenderFns } from "./ResourcePage.vue?vue&type=template&id=5beeb0c3"
import script from "./ResourcePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResourcePage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports